import styled from 'styled-components'
import { Icon } from 'antd'

const WrapIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.25);
`

export { WrapIcon }
